export const COMPANY_PROMOTIONS_HEAD_CELLS = [
  {
    id: 'position_index'
  },
  {
    id: 'id',
    label: 'ID'
  },
  {
    id: 'promotion_name',
    label: 'Название акции'
  },
  {
    id: 'short_description',
    label: 'Описание'
  },
  {
    id: 'start_at',
    label: 'Дата начала действия'
  },
  {
    id: 'end_at',
    label: 'Дата окончания действия'
  },
  {
    id: 'status',
    label: 'Статус акции'
  },
  {
    id: '',
    label: '',
    hideSortIcon: true
  }
];

export const PROMOTION_STATUSES = [
  {
    value: 'all',
    label: 'Все'
  },
  {
    value: 'NEW',
    label: 'Новая'
  },
  {
    value: 'IN_APPROVAL',
    label: 'На рассмотрении'
  },
  {
    value: 'REJECTED',
    label: 'Отклонена'
  },
  {
    value: 'APPROVED',
    label: 'Одобрена'
  },
  {
    value: 'ACTIVE',
    label: 'Активна'
  },
  {
    value: 'DEACTIVATED',
    label: 'Деактивирована'
  }
];

// Переходы между статусами согласно бэкенд-коду
export const STATUS_TRANSITIONS = {
  'NEW': ['IN_APPROVAL'],
  'IN_APPROVAL': ['REJECTED', 'APPROVED'],
  'REJECTED': ['IN_APPROVAL'],
  'APPROVED': ['ACTIVE'],
  'ACTIVE': ['DEACTIVATED'],
  'DEACTIVATED': []
};

export const PROMOTION_AVAILABILITY_OPTIONS = [
  {
    value: 'all',
    label: 'Всем'
  },
  {
    value: 'customer_id',
    label: 'По списку (customer_id)'
  }
];

export const BUTTON_TYPES = [
  {
    value: 'external',
    label: 'Внешняя ссылка'
  },
  {
    value: 'internal',
    label: 'Внутренняя ссылка (МП)'
  }
];

export const LANGUAGES = [
  {
    value: 'ru',
    label: 'RU'
  },
  {
    value: 'kk',
    label: 'KK'
  },
  {
    value: 'en',
    label: 'EN'
  }
];

export const SUPPORTED_FILE_TYPES = ['.jpg', '.png', '.webp'];
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

// Константы для валидации
export const VALIDATION_RULES = {
  NAME_MIN_LENGTH: 3,
  NAME_MAX_LENGTH: 100,
  DESCRIPTION_MIN_LENGTH: 10,
  DESCRIPTION_MAX_LENGTH: 1000,
  PHONE_PATTERN: /^\+?[1-9]\d{1,14}$/,
  URL_PATTERN: /^https?:\/\/.+/,
  INTERNAL_LINK_PATTERN: /^\//
};

// Константы для дебаунса
export const DEBOUNCE_DELAYS = {
  SEARCH: 500,
  VALIDATION: 300,
  API_CALL: 1000
};

// Константы для пагинации
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100]
};

// Константы для статусов загрузки
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

// Константы для типов уведомлений
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// Сообщения об успехе
export const SUCCESS_MESSAGES = {
  PROMOTION_CREATED: 'Акция успешно создана!',
  PROMOTION_UPDATED: 'Акция успешно обновлена!',
  PROMOTION_DELETED: 'Акция успешно удалена!',
  STATUS_UPDATED: 'Статус акции успешно обновлен!',
  BUTTON_CREATED: 'Кнопка успешно создана!',
  INITIATOR_CREATED: 'Инициатор успешно создан!'
};

// Сообщения об ошибках
export const ERROR_MESSAGES = {
  GENERIC: 'Произошла ошибка. Попробуйте еще раз.',
  NETWORK: 'Ошибка сети. Проверьте подключение к интернету.',
  VALIDATION: 'Пожалуйста, исправьте ошибки в форме.',
  FILE_TOO_LARGE: 'Размер файла превышает допустимый лимит.',
  INVALID_FILE_TYPE: 'Неподдерживаемый тип файла.',
  REQUIRED_FIELD: 'Это поле обязательно для заполнения.'
};
